import { render, staticRenderFns } from "./CardsListTag.vue?vue&type=template&id=b03968ba&"
import script from "./CardsListTag.vue?vue&type=script&lang=js&"
export * from "./CardsListTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports